import { render, staticRenderFns } from "./recibo-pagamento-escola-esca.vue?vue&type=template&id=6d08c1f2&scoped=true&"
import script from "./recibo-pagamento-escola-esca.vue?vue&type=script&lang=js&"
export * from "./recibo-pagamento-escola-esca.vue?vue&type=script&lang=js&"
import style0 from "./recibo-pagamento-escola-esca.vue?vue&type=style&index=0&id=6d08c1f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08c1f2",
  null
  
)

export default component.exports